module.exports = __webpack_public_path__ + "static/media/BelliesAtelierLogo.e3787951.jpg";